import { Route, Routes } from "react-router-dom";

import { BankAccountForm } from "./BankAccountForm";
import { IBankAccountViewProps } from "./BankAccounts";
import { bankAccountsDisplayFormatter } from "./bankAccountsDisplayFormatter";
import { QuickTable, QuickTableFilterTabs } from "../../components";

import infoBlueIcon from "../../assets/icons/info_blue.svg";
import { PayoutSettings } from "./PayoutSettings";
import { BankAccountTagForm } from "./BankAccountTagForm";

export const View = (props: IBankAccountViewProps) => {
  return (
    <>
      {!props.defaultCurrency ? null : (
        <div style={{ padding: "20px" }} className="top-into--business-details">
          <div>
            <img alt="information" src={infoBlueIcon} />
          </div>
          <div>
            Collections and charges for currencies that have not been enabled
            will be converted to your default currency, {props.defaultCurrency}.
          </div>
        </div>
      )}

      <QuickTable
        id="productsTable"
        data={props.data}
        headers={props.headers}
        isLoading={props.isLoading}
        isError={props.isError}
        itemCount={props.totalCount}
        renderDetail={(item) => item.account_number}
        toolbarTabs={
          <QuickTableFilterTabs
            queryStringTabNavLinks={props.queryStringTabs}
          />
        }
        displayFormatter={bankAccountsDisplayFormatter}
        onExport={props.onExport}
        openCreateNewModal={props.openCreateNewModal}
        createNewButtonText="Add Bank Account"
      />
      <PayoutSettings />

      <BankAccountForm
        refreshTable={props.refreshTable}
        isModalOpen={props.isCreateNewModalOpen}
        closeModal={props.closeModal}
      />

      <Routes>
        {/* <Route
          path="create/*"
          element={
            <BankAccountForm
              refreshTable={props.refreshTable}
              isModalOpen={props.isCreateNewModalOpen}
              closeModal={props.closeModal}
            />
          }
        /> */}

        <Route
          path=":bank_account_id/tags/append/*"
          element={
            <BankAccountTagForm
            // refreshTable={props.refreshTable}
            />
          }
        />
      </Routes>
    </>
  );
};
